import { useTheme } from "../../contexts/ThemeContext";
import Modal from "../ui/Modal";

// Dialog com 3 opções pra ações que impactam a despesa linkada de uma tarefa.
// mode="delete"      → deletar tarefa + decidir destino da despesa
// mode="remove-value" → salvar tarefa sem valor + decidir destino da despesa
export default function TarefaDespesaActionDialog({
  open,
  mode,
  tarefaTitulo,
  loading,
  onCancel,
  onChoose,
}) {
  const { C } = useTheme();

  const title = mode === "delete" ? "Excluir tarefa e despesa?" : "Remover valor da tarefa?";

  const headline =
    mode === "delete"
      ? `Esta tarefa gerou uma despesa vinculada. O que fazer com ela?`
      : `Você removeu o valor de "${tarefaTitulo ?? "tarefa"}". Como quer tratar a despesa já criada?`;

  const options = [
    {
      key: "delete",
      label: mode === "delete" ? "Excluir tarefa e cancelar a despesa" : "Cancelar a despesa também",
      desc: "Remove a despesa do Financeiro. Use quando a compra não vai acontecer.",
      danger: true,
    },
    {
      key: "unlink",
      label: mode === "delete" ? "Excluir tarefa e manter a despesa" : "Manter a despesa (desvincular)",
      desc: "A despesa continua no Financeiro sem vínculo com a tarefa. Use quando a compra já foi feita.",
      danger: false,
    },
  ];

  return (
    <Modal open={open} onClose={loading ? undefined : onCancel} title={title} width={480}>
      <p
        style={{
          margin: "0 0 16px",
          fontSize: 13,
          color: C.textMuted,
          lineHeight: 1.5,
        }}
      >
        {headline}
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {options.map((opt) => (
          <button
            key={opt.key}
            type="button"
            onClick={() => onChoose(opt.key)}
            disabled={loading}
            style={{
              textAlign: "left",
              padding: "14px 16px",
              borderRadius: 10,
              border: `1px solid ${opt.danger ? C.red + "60" : C.border}`,
              background: opt.danger ? C.redDim : C.bg,
              color: opt.danger ? C.red : C.text,
              fontSize: 13,
              fontWeight: 600,
              cursor: loading ? "wait" : "pointer",
              fontFamily: "'DM Sans', sans-serif",
              opacity: loading ? 0.6 : 1,
            }}
          >
            <div>{opt.label}</div>
            <div
              style={{
                fontSize: 11,
                fontWeight: 500,
                color: C.textMuted,
                marginTop: 4,
                lineHeight: 1.4,
              }}
            >
              {opt.desc}
            </div>
          </button>
        ))}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: 18,
          paddingTop: 14,
          borderTop: `1px solid ${C.border}`,
        }}
      >
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          style={{
            padding: "10px 18px",
            borderRadius: 10,
            border: `1px solid ${C.border}`,
            background: "transparent",
            color: C.textMuted,
            fontSize: 13,
            fontWeight: 600,
            cursor: loading ? "not-allowed" : "pointer",
            fontFamily: "'DM Sans', sans-serif",
          }}
        >
          Voltar
        </button>
      </div>
    </Modal>
  );
}
